import { render, staticRenderFns } from "./EmbeddedSmartCollection.vue?vue&type=template&id=cfa816a6&"
import script from "./EmbeddedSmartCollection.vue?vue&type=script&lang=js&"
export * from "./EmbeddedSmartCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SmartCollection: require('/app/appsumo/nuxt/components/smartcollections/SmartCollection.vue').default})
